// @flow
import {
  Button,
  CardActions,
  CircularProgress,
  Fab,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  RadioGroup,
  Radio,
  TextField,
  Typography,
} from '@material-ui/core';
import Card from '@material-ui/core/Card';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { Link, Route, withRouter } from 'react-router-dom';

import Loading from '../../components/Loading';
import OrganizationsSearchResults from '../../components/OrganizationSearchResults';
import OpenOrDownloadAvaAppComponent from '../../components/OpenOrDownloadAvaAppComponent';
import PhraseMarkdownText from '../../components/PhraseMarkdownText';
import { analytics } from '../../firebase';
import * as avaApi from '../../services/api/ava';
import * as saasApi from '../../services/api/saas';
import { triggerOrgTrial } from '../../services/api/subscription';
import LocalStorage, { STORAGE_KEYS } from '../../services/localStorage';
import * as segment from '../../utils/segment';
import { getOS } from '../../utils';

import Work from '../../../assets/images/work-laptop.svg';
import School from '../../../assets/images/school.svg';
import Event from '../../../assets/images/event.svg';
import Video from '../../../assets/images/video.svg';
import DeafEmoji from '../../../assets/images/deafEmoji.png';
import HohEmoji from '../../../assets/images/hohEmoji.png';
import EarEmoji from '../../../assets/images/earEmoji.png';
import SomeoneSpeaking from '../../../assets/images/someoneSpeaking.png';
import addOrg from '../../../assets/icons/add_org.svg';
import hrOrg from '../../../assets/icons/hr.svg';
import eduOrg from '../../../assets/icons/edu.svg';
import eventOrg from '../../../assets/icons/event.svg';
import LoginBackground from '../../../assets/images/swipeBackground.svg';

const styles = theme => ({
  outerWrap: {
    margin: '0 auto',
    maxWidth: 600,
    width: '100%',
  },
  title: {
    fontWeight: 700,
  },
  orgTypeOptionsWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: theme.spacing(4),
    width: '100%',
  },
  orgTypeButton: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      textDecoration: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      '& h6': {
        fontSize: '1rem',
      },
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      marginBottom: theme.spacing(2),
      width: `calc(50% - ${theme.spacing(1)}px)`,
    },
    background: 'transparent',
    border: `2px solid ${theme.palette.border}`,
    borderRadius: 12,
    flexGrow: 0,
    marginBottom: theme.spacing(4),
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
    WebkitAppearance: 'none',
    width: `calc(50% - ${theme.spacing(2)}px)`,
  },
  orgTypeIllustration: {
    width: '100%',
  },
  orgInfoOptionsWrap: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 auto',
    marginTop: theme.spacing(2),
    maxWidth: 420,
    width: '100%',
  },
  formControl: {
    marginBottom: theme.spacing(2),
  },
  formLabel: {
    fontSize: '1em',
    marginBottom: 8,
    zIndex: 1,
  },
  helperText: {
    marginLeft: 14,
  },
  checkboxHelperText: {
    lineHeight: 3,
  },
  orgTypeLabel: {
    textTransform: 'capitalize',
  },
  noDecorationLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  button: {
    boxShadow: 'none',
    fontWeight: 700,
    marginTop: theme.spacing(2),
  },
  centerText: {
    textAlign: 'center',
  },
  fab: {
    backgroundColor: 'white',
    textTransform: 'none',
    fontSize: 18,
    color: '#102867',
    fontWeight: 400,
    height: 94,
    textAlign: 'left',
    display: 'flex',
    marginBottom: theme.spacing(4),
  },
  fabBold: {
    fontWeight: 800,
  },
  fabContainer: {
    display: 'flex',
    maxWidth: 270,
    margin: 'auto',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  fabContainerVoicingProfile: {
    display: 'flex',
    maxWidth: 300,
    margin: 'auto',
  },
  fabMargin: {
    marginRight: 17,
    marginLeft: 17,
    height: 55,
  },
  orgaSearchProgress: {
    position: 'absolute',
    width: 20,
    height: 20,
    right: 17,
    top: 17,
    color: theme.palette.ava.blue,
  },
  searchFieldWithPadding: {
    paddingLeft: 30,
  },
  searchResultTypePicto: {
    position: 'absolute',
    left: 9,
    top: 18,
    width: 25,
  },
  loginImageContainer: {
    width: '100vw',
    marginTop: 40,
    [theme.breakpoints.only('xs')]: {
      height: 250,
      paddingTop: 60,
    },
    [theme.breakpoints.only('sm')]: {
      height: 300,
      paddingTop: 70,
    },
    [theme.breakpoints.up('md')]: {
      height: 400,
      paddingTop: 100,
    },
    bottom: 70,
    backgroundImage: `url(${LoginBackground})`,
    backgroundSize: '109vw 130%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  illustration: {
    height: '100%',
  },
  blueTitle: {
    color: '#0679B4',
    fontWeight: 'normal',
    marginTop: -13,
  },
  blueTitleSmall: {
    color: '#0679B4',
    fontWeight: 'normal',
    fontSize: 25,
  },
  maybeLater: {
    color: '#828282',
    textDecoration: 'underline',
    border: 'none',
    backgroundColor: 'transparent',
    outline: 'none',
  },
  bigButton: {
    padding: '12px 35px',
    borderRadius: 27,
    marginBottom: 10,
    fontWeight: 'bold',
  },
});

type Props = {
  classes: Object,
  firebaseUser: Object,
  i18n: Object,
  history: Object,
  location: Object,
  t: Function,
};

type State = {
  userName: string,
  userNameRequiredError: boolean,
  userNameResError: boolean,
  orgType: string,
  isAdmin?: string,
  isAdminRequiredError: boolean,
  orgId?: string,
  inputOrgName?: string,
  orgName?: string,
  orgNameRequiredError: boolean,
  loading: boolean,
  resError?: string,
  hearingProfile?: string,
  organizationsSearchResults: Object,
  currentlySearchingOrganizations: boolean,
  openOrDownloadAvaApp: boolean,
  orgInputFocused: boolean,
};

class ScribeLoginProfiling extends React.Component<Props, State> {
  findOrganizationsByOrgName = null;

  currentOrganizationSearch = null;

  constructor(props: Props) {
    super(props);
    this.state = {
      userName: '',
      orgType: 'hr',
      isAdmin: '',
      userNameRequiredError: false,
      userNameResError: false,
      isAdminRequiredError: false,
      orgNameRequiredError: false,
      orgId: undefined,
      inputOrgName: '',
      loading: false,
      hearingProfile: undefined,
      organizationsSearchResults: null,
      currentlySearchingOrganizations: false,
      openOrDownloadAvaApp: false,
      orgInputFocused: false,
    };
    this.findOrganizationsByOrgName = _.debounce(this.fetchOrganizationsByOrgName, 500);
  }

  setUserName = e => {
    this.setState({
      userName: e.target.value,
      userNameRequiredError: false,
    });
  };

  disabledUsername() {
    const { userName } = this.state;
    return !userName;
  }

  submitUserName = e => {
    e.preventDefault();
    const { userName } = this.state;
    if (userName) {
      const { firebaseUser } = this.props;
      const avaId = window.localStorage.getItem('avaId');
      this.setState({ loading: true });

      avaApi.users
        .updateUserName({
          avaId,
          firebaseAuthUID: firebaseUser.uid,
          userName,
        })
        .then(res => res.data)
        .then(res => {
          if (res.ok) {
            segment.track('Updated Name', { Name: userName });
            segment.identify({ name: userName });
            const { location, history } = this.props;
            const locationArray = location.pathname.split('/');
            this.setState({
              loading: false,
            });
            if (locationArray[locationArray.length - 1] === 'user-name-subscribed') {
              if (!window.isElectron) {
                history.push(`/${locationArray[1]}/login/profile/app-bridge`);
              } else if (location.pathname.split('/')[1] === 'web') {
                history.push('/web/?startConvo=true');
              }
            } else if (locationArray[1] === 'web') {
              history.push('/web/login/profile/hearing-profile');
            }
          } else {
            this.setState({
              loading: false,
              userNameResError: true,
            });
          }
        })
        .catch(err => {
          this.setState({
            loading: false,
            userNameResError: true,
          });
        });
    } else {
      this.setState({
        userNameRequiredError: true,
      });
    }
  };

  patchProfile = (profile: number) => {
    const { firebaseUser } = this.props;
    const avaId = window.localStorage.getItem('avaId');

    avaApi.users.updateHearingProfile({
      avaId,
      firebaseAuthUID: firebaseUser.uid,
      hearingProfile: profile,
    });
  };

  setHearingProfile = hearingProfile => {
    const { userName } = this.state;
    const avaId = window.localStorage.getItem('avaId');

    segment.track('Hearing Profiled', {
      'Hearing Profile': hearingProfile,
    });
    segment.identify({
      'Hearing Profile': hearingProfile,
    });
    this.setState({ hearingProfile });
    const { location, history } = this.props;
    const locationArray = location.pathname.split('/');
    if (hearingProfile === 'hearing') {
      history.push(`/${locationArray[1]}/login/profile/org-type`);
      this.patchProfile(2);
    } else {
      history.push(`/${locationArray[1]}/login/profile/voicing-profile`);
    }
  };

  setVoicingProfile = voicingProfile => {
    segment.track('Voice Checked', {
      Voice: voicingProfile,
    });
    segment.identify({
      Voice: voicingProfile,
    });
    const { hearingProfile } = this.state;
    const { location, history } = this.props;
    const locationArray = location.pathname.split('/');
    history.push(`/${locationArray[1]}/login/profile/org-type`);
    if (hearingProfile === 'hard-of-hearing') {
      if (voicingProfile === 'not voicing') {
        this.patchProfile(3);
      } else {
        this.patchProfile(1);
      }
    } else if (hearingProfile === 'deaf') {
      if (voicingProfile === 'not voicing') {
        this.patchProfile(4);
      } else {
        this.patchProfile(0);
      }
    }
  };

  setOrgType = orgType => {
    const { firebaseUser } = this.props;

    if (orgType === 'video') {
      this.setState({
        loading: true,
      });

      segment.track('Role Profiled', { Role: 'user' });
      segment.identify({ Role: 'user' });
      const avaId = window.localStorage.getItem('avaId');

      triggerOrgTrial(avaId, firebaseUser.uid)
        .then(trialRes => trialRes.data)
        .then(trialRes => {
          this.setState({ loading: false });
          if (trialRes.ok) {
            const { location, history } = this.props;
            if (!window.isElectron) {
              const locationArray = location.pathname.split('/');
              history.push(`/${locationArray[1]}/login/profile/app-bridge`);
            } else if (location.pathname.split('/')[1] === 'web') {
              history.push('/web/?startConvo=true');
            }
          } else {
            this.setState({
              loading: false,
              resError: 'newTrialError',
            });
          }
        })
        .catch(err => {
          this.setState({
            loading: false,
            resError: 'newTrialError',
          });
        });
    } else {
      this.setState({
        orgType,
      });
    }
    const market = orgType === 'video' ? 'ind' : orgType;
    segment.track('Market Profiled', { Market: market });
    segment.identify({ Market: market });
  };

  setIsAdmin = e => {
    this.setState({
      isAdmin: e.target.value,
      isAdminRequiredError: false,
      resError: '',
    });
  };

  fetchOrganizationsByOrgName = async orgName => {
    const { firebaseUser } = this.props;
    const { orgType, currentlySearchingOrganizations } = this.state;
    if (!currentlySearchingOrganizations) return;
    if (this.currentOrganizationSearch !== orgName) {
      // Because there is some delay, we may get answer from server
      // for something else than what is currently typed. We ignore it
      return;
    }

    const response = await avaApi.organizations.findOrganizations({
      firebaseAuthUID: firebaseUser.uid,
      orgName,
      orgType,
    });

    const { result } = response.data;
    const { resultFromParse, resultFromGoogle } = result || {};

    // We keep 3 results, parse first
    const organizations = (resultFromParse || []).slice(0, 3).map(r => ({
      name: r.name,
      id: r.objectId,
    }));

    if (organizations.length < 3) {
      const googleOrgs = (resultFromGoogle?.results || []).slice(0, 3 - organizations.length).map(r => ({
        name: r.name,
        address: r.formatted_address,
        id: r.place_id,
      }));
      organizations.push(...googleOrgs);
    }
    this.setState({
      organizationsSearchResults: organizations,
      currentlySearchingOrganizations: false,
    });
  };

  setOrgName = e => {
    this.setState({
      orgName: undefined,
      orgId: undefined,
      inputOrgName: e.target.value,
      orgNameRequiredError: false,
      resError: '',
    });
    if (e.target.value) {
      this.setState({
        currentlySearchingOrganizations: true,
      });
      this.currentOrganizationSearch = e.target.value;
      if (this.findOrganizationsByOrgName) {
        this.findOrganizationsByOrgName(e.target.value);
      }
    } else {
      this.currentOrganizationSearch = null;
      this.setState({
        currentlySearchingOrganizations: false,
        organizationsSearchResults: null,
      });
    }
  };

  submit = e => {
    e.preventDefault();
    const { firebaseUser } = this.props;
    const { isAdmin, orgName } = this.state;
    const userRole = isAdmin === 'yes' ? 'admin' : 'user';

    if (!isAdmin || !orgName) {
      this.setState({
        isAdminRequiredError: !isAdmin,
        orgNameRequiredError: !orgName,
      });
    } else {
      segment.track('Organization Profiled', { 'Organization Name': orgName });
      segment.track('Role Profiled', { Role: userRole });
      segment.identify({ Role: userRole });
      this.setState({
        resError: '',
        isAdminRequiredError: false,
        orgNameRequiredError: false,
        loading: true,
      });
      const { orgType, orgId } = this.state;
      saasApi.organizations
        .createOrganization({
          type: orgType,
          name: orgName,
          role: userRole,
          placeId: orgId,
        })
        .then(orgRes => orgRes.data)
        .then(orgRes => {
          if (orgRes.organization) {
            const avaId = window.localStorage.getItem('avaId');
            let type;

            switch (orgType) {
              case 'hr':
              case 'edu':
                type = 'Pro';
                break;
              case 'worship':
                type = 'Welcome';
                break;
              default:
                type = 'Free';
                break;
            }

            avaApi.users.updateRole({
              avaId: window.localStorage.getItem('avaId'),
              firebaseAuthUID: firebaseUser.uid,
              role: userRole,
            });

            triggerOrgTrial(avaId, firebaseUser.uid)
              .then(trialRes => trialRes.data)
              .then(trialRes => {
                if (trialRes.ok) {
                  const { userName } = this.state;
                  const { firebaseUser, i18n } = this.props;
                  const avaId = window.localStorage.getItem('avaId');
                  const params = {
                    chn: 'inb',
                    src: 'onb',
                    med: window.isElectron ? 'desk' : 'web',
                    mkt: orgType,
                    avaid: avaId,
                    name: userName,
                    orgname: orgName,
                    role: userRole,
                    utm_campaign: window.utm_parameters && window.utm_parameters.name,
                    ...(firebaseUser.email && { email: firebaseUser.email }),
                    ...(firebaseUser.phoneNumber && { phone: firebaseUser.phoneNumber }),
                  };
                  let baseUrl;
                  switch (i18n.language) {
                    case 'fr':
                      baseUrl = 'https://ava-me.typeform.com/to/R8L5rC';
                      break;
                    case 'en':
                    default:
                      baseUrl = 'https://ava-me.typeform.com/to/q2n11h';
                      break;
                  }
                  const url = `${baseUrl}${Object.keys(params).reduce(
                    (acc, cur) => `${acc}&${cur}=${params[cur]}`,
                    '?'
                  )}#userid=${LocalStorage.get(STORAGE_KEYS.AVA_ID) || ''}`;
                  if (isAdmin === 'yes') {
                    analytics.logEvent('app_submitted_typeform', {
                      channel: 'inbound',
                      source: 'onboarding',
                      market: orgType,
                      plan: 'Free',
                      organization_name: orgName,
                    });
                  }
                  const { location, history } = this.props;
                  if (window.electronShell && isAdmin === 'yes') {
                    window.electronShell.openExternal(url);
                    window.location.href = '/';
                  } else if (!window.isElectron && isAdmin === 'yes') {
                    window.location.href = url;
                  } else if (window.isElectron && isAdmin !== 'yes') {
                    history.push('/web/?startConvo=true');
                  } else if (!window.isElectron && isAdmin !== 'yes') {
                    const locationArray = location.pathname.split('/');
                    history.push(`/${locationArray[1]}/login/profile/app-bridge`);
                  }
                } else {
                  this.setState({
                    loading: false,
                    resError: 'newTrialError',
                  });
                }
              })
              .catch(err => {
                this.setState({
                  loading: false,
                  resError: 'newTrialError',
                });
              });
          } else if (
            orgRes.error &&
            orgRes.error.error &&
            orgRes.error.error.content &&
            orgRes.error.error.content.errorCode === 'adminAlreadyExists'
          ) {
            this.setState({
              loading: false,
              resError: 'adminAlreadyExists',
            });
          } else {
            this.setState({
              loading: false,
              resError: 'unexpected',
            });
          }
        })
        .catch(err => {
          this.setState({
            loading: false,
            resError: 'unexpected',
          });
        });
    }
  };

  openOrDownloadAvaApp() {
    // Since it's based on rendering a component,
    // we toggle the visibility alltogether
    this.setState({ openOrDownloadAvaApp: false });
    setTimeout(() => {
      this.setState({ openOrDownloadAvaApp: true });
    }, 0);
  }

  render() {
    const { classes, t, i18n } = this.props;
    const {
      userNameRequiredError,
      userNameResError,
      isAdmin,
      isAdminRequiredError,
      orgName,
      orgId,
      orgNameRequiredError,
      orgType,
      inputOrgName,
      resError,
      loading,
      organizationsSearchResults,
      currentlySearchingOrganizations,
      openOrDownloadAvaApp,
      orgInputFocused,
    } = this.state;

    let organizationSearchResultPicto;
    switch (orgType) {
      case 'edu':
        organizationSearchResultPicto = eduOrg;
        break;
      case 'event':
        organizationSearchResultPicto = eventOrg;
        break;
      default:
        organizationSearchResultPicto = hrOrg;
        break;
    }

    return (
      <div className={classes.outerWrap}>
        <Route
          path={['/web/login/profile/user-name', '/web/login/profile/user-name-subscribed']}
          render={() => {
            return (
              <div>
                <form className={classes.orgInfoOptionsWrap}>
                  <Typography variant="h4" align="center" className={classes.title} gutterBottom>
                    {t('profiling.userName.heading')}
                  </Typography>
                  <Typography variant="body1" align="center" gutterBottom>
                    {t(`profiling.userName.body`)}
                  </Typography>
                  <FormControl className={classes.formControl} component="fieldset" margin="normal">
                    <TextField
                      required
                      fullWidth
                      onChange={e => this.setUserName(e)}
                      label={t('profiling.userName.label')}
                      variant="outlined"
                      error={userNameRequiredError}
                    />
                    {userNameRequiredError && (
                      <FormHelperText error className={classes.helperText}>
                        {t('profiling.userName.required')}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={this.submitUserName}
                    disabled={this.disabledUsername() || !!loading}
                  >
                    {loading && <CircularProgress size={20} color="secondary" />}
                    {!loading && t('profiling.userName.continue')}
                  </Button>
                  {userNameResError && (
                    <FormHelperText error className={classes.centerText}>
                      {t(`profiling.userName.resError`)}
                    </FormHelperText>
                  )}
                </form>
              </div>
            );
          }}
        />
        <Route
          path={['/web/login/profile/hearing-profile']}
          render={() => {
            return (
              <div>
                <Typography variant="h4" align="center" className={classes.title} gutterBottom>
                  {t('profiling.hearingProfile.heading')}
                </Typography>
                <Typography variant="body1" align="center" gutterBottom>
                  {t('profiling.hearingProfile.body')}
                </Typography>
                <div className={classes.fabContainer}>
                  <Fab variant="extended" className={classes.fab} onClick={() => this.setHearingProfile('deaf')}>
                    <div style={{ flexGrow: 1, marginRight: 12 }}>
                      <PhraseMarkdownText phraseKey="profiling.hearingProfile.deaf" />
                    </div>
                    <div>
                      <img src={DeafEmoji} alt="deaf" />
                    </div>
                  </Fab>
                  <Fab
                    variant="extended"
                    className={classes.fab}
                    onClick={() => this.setHearingProfile('hard-of-hearing')}
                  >
                    <div style={{ flexGrow: 1 }}>
                      <PhraseMarkdownText phraseKey="profiling.hearingProfile.hoh" />
                    </div>
                    <div>
                      <img src={HohEmoji} alt="hard of hearing" />
                    </div>
                  </Fab>
                  <Fab variant="extended" className={classes.fab} onClick={() => this.setHearingProfile('hearing')}>
                    <div style={{ flexGrow: 1, marginRight: 12 }}>
                      <PhraseMarkdownText phraseKey="profiling.hearingProfile.hearing" />
                    </div>
                    <div>
                      <img src={EarEmoji} alt="ear" />
                    </div>
                  </Fab>
                </div>
              </div>
            );
          }}
        />
        <Route
          path={['/web/login/profile/voicing-profile']}
          render={() => {
            return (
              <div>
                <Typography variant="h4" align="center" className={classes.title} gutterBottom>
                  {t('profiling.voicingProfile.heading')}
                </Typography>
                <Typography variant="body1" align="center" gutterBottom>
                  {t('profiling.voicingProfile.body')}
                </Typography>
                <img
                  src={SomeoneSpeaking}
                  alt="someone speaking"
                  style={{ maxWidth: 300, margin: 'auto', display: 'block' }}
                />
                <div className={classes.fabContainerVoicingProfile}>
                  <Fab
                    variant="extended"
                    className={[classes.fab, classes.fabMargin]}
                    onClick={() => this.setVoicingProfile('voicing')}
                  >
                    <span className={classes.fabBold}>{t('profiling.voicingProfile.yes')}</span>
                  </Fab>
                  <Fab
                    variant="extended"
                    className={[classes.fab, classes.fabMargin]}
                    onClick={() => this.setVoicingProfile('not voicing')}
                  >
                    <span className={classes.fabBold}>{t('profiling.voicingProfile.notAlways')}</span>
                  </Fab>
                </div>
              </div>
            );
          }}
        />
        <Route
          path={['/web/login/profile/org-type']}
          render={() => {
            if (loading) {
              return <Loading text={t('loading3d')} />;
            }
            return (
              <div>
                <Typography variant="h4" align="center" className={classes.title} gutterBottom>
                  {t('profiling.orgType.heading')}
                </Typography>
                <Typography variant="body1" align="center" gutterBottom>
                  {t('profiling.orgType.body')}
                </Typography>
                <div className={classes.orgTypeOptionsWrap}>
                  <Link
                    to="org-info"
                    type="button"
                    className={classes.orgTypeButton}
                    onClick={() => this.setOrgType('hr')}
                    style={{ color: 'rgb(75, 75, 75' }}
                  >
                    <Typography variant="h6" align="center" className={classes.title} gutterBottom>
                      {t('profiling.orgType.work')}
                    </Typography>
                    <img
                      src={Work}
                      alt="Laptop with Ava captioning on screen"
                      className={classes.orgTypeIllustration}
                    />
                  </Link>
                  <Link
                    to="org-info"
                    type="button"
                    className={classes.orgTypeButton}
                    onClick={() => this.setOrgType('edu')}
                    style={{ color: 'rgb(75, 75, 75' }}
                  >
                    <Typography variant="h6" align="center" className={classes.title} gutterBottom>
                      {t('profiling.orgType.school')}
                    </Typography>
                    <img
                      src={School}
                      alt="Laptop with Ava captioning on screen"
                      className={classes.orgTypeIllustration}
                    />
                  </Link>
                  <Link
                    to="org-info"
                    type="button"
                    className={classes.orgTypeButton}
                    onClick={() => this.setOrgType('event')}
                    style={{ color: 'rgb(75, 75, 75' }}
                  >
                    <Typography variant="h6" align="center" className={classes.title} gutterBottom>
                      {t('profiling.orgType.event')}
                    </Typography>
                    <img
                      src={Event}
                      alt="Laptop with Ava captioning on screen"
                      className={classes.orgTypeIllustration}
                    />
                  </Link>
                  <button
                    type="button"
                    className={classes.orgTypeButton}
                    onClick={() => this.setOrgType('video')}
                    style={{ color: 'rgb(75, 75, 75' }}
                  >
                    <Typography variant="h6" align="center" className={classes.title} gutterBottom>
                      {t('profiling.orgType.video')}
                    </Typography>
                    <img
                      src={Video}
                      alt="Laptop with Ava captioning on screen"
                      className={classes.orgTypeIllustration}
                    />
                  </button>
                </div>
              </div>
            );
          }}
        />
        <Route
          path={['/web/login/profile/org-info']}
          render={() => {
            return (
              <div>
                <form className={classes.orgInfoOptionsWrap}>
                  <Typography variant="h4" align="center" className={classes.title} gutterBottom>
                    {t(`profiling.orgInfo.heading.${orgType}`)}
                  </Typography>
                  <Typography variant="body1" align="center" gutterBottom>
                    {t(`profiling.orgInfo.body`)}
                  </Typography>
                  <FormControl className={classes.formControl} component="fieldset" margin="normal">
                    <div style={{ position: 'relative' }}>
                      <TextField
                        required
                        fullWidth
                        value={orgName || inputOrgName}
                        onChange={e => this.setOrgName(e)}
                        label={t(`profiling.orgInfo.orgName.label.${orgType}`)}
                        variant="outlined"
                        error={resError === 'adminAlreadyExists'}
                        InputProps={{
                          className: orgName && classes.searchFieldWithPadding,
                        }}
                        onFocus={() => {
                          this.setState({
                            orgInputFocused: true,
                          });
                        }}
                        onBlur={() => {
                          // Blur after timeout
                          // so time to select value
                          setTimeout(() => {
                            const { orgName: currentOrgName } = this.state;
                            this.setState({
                              orgInputFocused: false,
                              orgName: currentOrgName || inputOrgName,
                            });
                          }, 150);
                        }}
                      />
                      {orgName && (
                        <img
                          className={classes.searchResultTypePicto}
                          alt="search result picto"
                          src={orgId ? organizationSearchResultPicto : addOrg}
                        />
                      )}
                      {currentlySearchingOrganizations && (
                        <CircularProgress size={20} className={classes.orgaSearchProgress} />
                      )}
                      {orgInputFocused && inputOrgName && organizationsSearchResults && (
                        <OrganizationsSearchResults
                          searchResults={organizationsSearchResults}
                          query={inputOrgName}
                          onSelectResult={result => {
                            this.setState({
                              orgName: result.name,
                              orgId: result.id,
                            });
                          }}
                          orgType={orgType}
                        />
                      )}
                    </div>
                    {orgNameRequiredError && (
                      <FormHelperText error className={classes.helperText}>
                        {t('profiling.orgInfo.required')}
                      </FormHelperText>
                    )}
                    {resError === 'adminAlreadyExists' && (
                      <FormHelperText error className={classes.helperText}>
                        {t('profiling.orgInfo.res.adminAlreadyExists')}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl component="fieldset" margin="none" required>
                    <FormLabel component="legend" className={classes.formLabel}>
                      {t(`profiling.orgInfo.isAdmin.${orgType}`)}
                    </FormLabel>
                    <RadioGroup value={isAdmin} onChange={e => this.setIsAdmin(e)} row>
                      <FormControlLabel value="yes" control={<Radio />} label={t('profiling.orgInfo.isAdmin.yes')} />
                      <FormControlLabel value="no" control={<Radio />} label={t('profiling.orgInfo.isAdmin.no')} />
                      {isAdminRequiredError && (
                        <FormHelperText error className={classes.checkboxHelperText}>
                          {t('profiling.orgInfo.required')}
                        </FormHelperText>
                      )}
                    </RadioGroup>
                  </FormControl>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={e => this.submit(e)}
                    disabled={!orgName}
                  >
                    {loading && <CircularProgress size={20} color="secondary" />}
                    {!loading && t('profiling.orgInfo.continue')}
                  </Button>
                  {resError === 'newTrialError' && (
                    <FormHelperText error className={classes.centerText}>
                      {t(`profiling.orgInfo.res.newTrialError`)}
                    </FormHelperText>
                  )}
                  {resError === 'unexpected' && (
                    <FormHelperText error className={classes.centerText}>
                      {t(`profiling.orgInfo.res.unexpectedError`)}
                    </FormHelperText>
                  )}
                </form>
              </div>
            );
          }}
        />
        <Route
          path={['/web/login/profile/app-bridge']}
          render={() => {
            return (
              <>
                <Card
                  style={{
                    boxShadow: 'none',
                    marginBottom: '20px',
                    textAlign: 'center',
                  }}
                >
                  <CardActions>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '0 auto 12px',
                      }}
                    >
                      <Typography variant="h4" className={classes.blueTitle} align="center" gutterBottom>
                        {t('profiling.appBridge.captionsForAnyVideo')}
                      </Typography>
                      <Typography variant="h4" className={classes.blueTitleSmall} align="center" gutterBottom>
                        {t('profiling.appBridge.frontAndCenter')}
                      </Typography>
                    </div>
                  </CardActions>
                </Card>
                <div style={{ textAlign: 'center', marginTop: '50%', position: 'relative' }}>
                  <div className={classes.loginImageContainer}>
                    <img
                      src={i18n.language === 'fr' ? '/newLoginBridgeFr.svg' : '/newLoginBridge.svg'}
                      alt="Laptop with Ava captioning on screen"
                      className={classes.illustration}
                    />
                  </div>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.bigButton}
                    onClick={() => this.openOrDownloadAvaApp()}
                    style={{ marginTop: 15 }}
                  >
                    {t('profiling.appBridge.downloadAvaDesktop', { OS: getOS() })}
                  </Button>

                  <Typography variant="subtitle1" align="center">
                    <button
                      className={classes.maybeLater}
                      type="button"
                      onClick={() => {
                        const { location, history } = this.props;
                        if (location.pathname.split('/')[1] === 'web') {
                          history.push('/web/?startConvo=true');
                        }
                      }}
                    >
                      {t('profiling.appBridge.maybeLater')}
                    </button>
                  </Typography>
                </div>
                {openOrDownloadAvaApp && <OpenOrDownloadAvaAppComponent newUser />}
              </>
            );
          }}
        />
      </div>
    );
  }
}
export default withTranslation()(withStyles(styles)(withRouter(ScribeLoginProfiling)));
